import { defineComponent as _defineComponent } from 'vue'
import {
  BaseText,
  ContextColorProvider,
  HeadingDisplay,
  HelperViewStatus,
  LoaderIndicator,
  NavBar
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import {
  Accordion,
  AccordionWrapper
} from '@/modules/common/components/Accordion';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { onMounted, ref } from 'vue';
import { FAQ, getFAQ } from '@/modules/trade/services/paid-custody';


export default /*#__PURE__*/_defineComponent({
  __name: 'FAQ',
  setup(__props) {

const faq = ref<FAQ | null>(null);
const hasError = ref(false);
const loading = ref(false);

onMounted(async () => {
  fetchFAQ();
});

const fetchFAQ = async () => {
  try {
    loading.value = true;
    hasError.value = false;

    const response = await getFAQ();

    faq.value = response;

    return true;
  } catch (e) {
    hasError.value = true;

    return false;
  } finally {
    loading.value = false;
  }
};

const footerContent = (faqUrl: string | undefined) => {
  return `
    Ainda com dúvidas? Acesse o nosso <a href="${faqUrl}">FAQ</a> ou entre em contato pelo
    e-mail <a href="mailto:meajuda@warren.com.br">meajuda@warren.com.br</a>.
    `;
};

return { __sfc: true,faq, hasError, loading, fetchFAQ, footerContent, BaseText, ContextColorProvider, HeadingDisplay, HelperViewStatus, LoaderIndicator, NavBar, BackButton, Accordion, AccordionWrapper, NebraskaColors }
}

})